import { BASE_URL } from "@/constants/config";
import { SiteCaptchaKey, VerifyCaptcha } from "@/services/dataTypes";


export const apiGetCaptcha = async (domain: string): Promise<SiteCaptchaKey> => {
    const response = await fetch(`${BASE_URL}/api/company/site_config?domain=${domain}`);
    const data = await response.json();
    return data;
};

export const apiVerifyCaptcha = async (domain: string, recaptcha_token: string): Promise<VerifyCaptcha> => {
    const response = await fetch(`${BASE_URL}/api/company/verify-captcha`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ domain, recaptcha_token }),
    });
    return await response.json();
};